<template>
  <div v-touch:swipe="showSwipe" class="notification">
    <notification-item
      :class="['notification__content', { swipe }]"
      :title="notification.title"
      :subTitle="notification.body"
      :time="translatedTime"
      :imageSrc="notification.imageUrl"
      :alt="notification.title"
      :canClose="!isSlideable"
      @click="handleClickNotificationItem"
      @dismiss="clearNotification"
    />
    <transition name="fade">
      <div
        v-if="swipe"
        class="notification__cta"
        @click.stop="clearNotification"
      >{{ $t('HOUSE_BOARD_CLEAR_ALL_NOTIFICATION_CONFIRM') }}</div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { NotificationItem } from '@sohohouse/design-system'
import { decorators } from '@sohohouse/platform-resources'

import UIMixin from '~/mixins/ui'

const { DateTime } = decorators.shared
const { mapActions: mapNotificationActions } = createNamespacedHelpers('notifications')

export default {
  components: {
    NotificationItem
  },

  mixins: [
    UIMixin
  ],

  props: {
    isSlideable: {
      type: Boolean,
      default: true
    },
    notification: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      swipe: false
    }
  },

  computed: {
    translatedTime () {
      const date = new DateTime(this.notification.createdAt)
      const timePassed = new DateTime().since(date, ['weeks', 'days', 'hours', 'minutes'])

      switch (true) {
        case timePassed.weeks > 0:
          return `${Math.ceil(timePassed.weeks)}w`
        case timePassed.days > 0:
          return `${Math.ceil(timePassed.days)}d`
        case timePassed.hours > 0:
          return `${Math.ceil(timePassed.hours)}h`
        case timePassed.minutes > 0:
          return `${Math.ceil(timePassed.minutes)}m`
        default:
          return '0m'
      }
    },

    navigationLink () {
      const { resourceId: id } = this.notification.navigation || {}

      return id ? this.localePath({ name: 'whats-on-details-id', params: { id } }) : ''
    }
  },

  methods: {
    ...mapNotificationActions(['dismissNotification']),

    showSwipe (value) {
      if (this.isSlideable) {
        if (value === 'left') this.swipe = true
        if (value === 'right') this.swipe = false
      }
    },

    clearNotification () {
      this.swipe = false
      this.dismissNotification(this.notification)
    },

    handleClickNotificationItem () {
      const { id } = this.$route.params || {}

      if (this.navigationLink) {
        if (id === this.notification.navigation.resourceId) {
          this.$ui.modal.close('house-board')
        }
        this.$router.push(this.navigationLink)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-bottom: $space-030;
  cursor: pointer;

  &__content {
    z-index: $notification-item-wrapper;
  }

  &__cta {
    background: $color-off-black;
    color: $color-white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    margin-left: $space-030;
    border-radius: $space-020;
    position: absolute;
    right: 0;
    width: 100%;
    max-width: 100px;
    height: 100%;
    z-index: $notification-item-clear;
  }
}

.swipe {
  margin-left: -100px;
  transition: all 0.2s ease;
}

.fade-enter-active {
  transition-delay: 0.2s;
  transition: opacity 0.2s;
}
.fade-enter {
  opacity: 0;
}
</style>
